module.exports = __webpack_public_path__ + "static/media/team.62d6de48.PNG";